import _export from '../internals/export.js';
import numberParseInt from '../internals/number-parse-int.js';

var $ = _export;
var $parseInt = numberParseInt; // `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix

$({
  global: true,
  forced: parseInt != $parseInt
}, {
  parseInt: $parseInt
});
